<template>
  <main class="main reverse"><div class="mainContents">
    <ul class="breadcrumb">
      <li><a href="/">トップページ</a></li>
      <li>イイネピアクイズ</li>
    </ul>
    <section class="main_content quiz_top">

      <h1 class="quiz_title">
        <div class="quiz_title_icon_left"></div>
        <div class="quiz_title_text">
          <span>イイネピアクイズ</span>
          <span class="sub">クイズに正解してポイントゲット！</span>
        </div>
        <div class="quiz_title_icon_right"></div>
      </h1>

      <template v-if="!isSetUp">
        <template v-if="!isLogin">
          <div class="quiz_no_login">
            <div class="quiz_no_login_image">
              <div class="submit_area">
                <a class="submit_bt" href="/login/"><span>会員登録/ログイン</span></a>
              </div>
            </div>
            <span>↓クイズはログイン後に参加できます↓</span>
          </div>
          <before-login-unanswered-list
            :page_number=pageNumber
            :qm_list="getBeforeLoginQmList"
            :qsm_lists="getBeforeLoginQsmLists"
            @clickSelection="clickSelectionHandler"
            @clickQuizButton="clickQuizButtonHandler"
          />
        </template>
        <template v-else>
          <div class="quiz_menu">
            <div class="quiz_filter">
              <button class="quiz_filter_unanswered" :style="quizFilterUnansweredStyle" :disabled=isUnansweredListView
                      @click="quizFilterClickHandler">
                チャレンジ
              </button>
              <button class="quiz_filter_answered" :style="quizFilterAnsweredStyle" :disabled=!isUnansweredListView
                      @click="quizFilterClickHandler">
                クリア
              </button>
            </div>
            <div class="point">
              <h2>現在のポイント<span class="montserrat">POINT</span></h2>
              <p><span>{{viewPoint}}</span></p>
            </div>
          </div>

          <template v-if="isUnansweredListView">
            <unanswered-list
              :page_number=pageNumber
              :qm_list="getUnansweredQmList"
              :qsm_lists="getUnansweredQsmLists"
              @clickSelection="clickSelectionHandler"
              @clickQuizButton="clickQuizButtonHandler"
            />
          </template>
          <template v-else>
            <answered-list
              :page_number=pageNumber
              :qm_list="getAnsweredQmList"
              :qsm_lists="getAnsweredQsmLists"
              @clickQuizButton="clickQuizButtonHandler"
            />
          </template>
          <quiz-result-correct-dialog v-if="isResultCorrect"
                                      :qm_id="resultCorrectInformationQmId"
                                      :point=resultCorrectInformationPoint
                                      :correct_text=resultCorrectInformationCorrectText
                                      :selection=resultCorrectInformationAnswerText
                                      :hint_url=resultCorrectInformationHintUrl
                                      @closeClick="resultCorrectCloseClickHandler"
                                      @clickQuizButton="clickQuizButtonHandler"
          />
          <quiz-result-incorrect-dialog v-if="isResultIncorrect"
                                        :qm_id="resultIncorrectInformationQmId"
                                        :hint_url=resultIncorrectInformationHintUrl
                                        @closeClick="resultIncorrectCloseClickHandler"
                                        @clickQuizButton="clickQuizButtonHandler"
          />
          <page-navigation v-if="limitedQmListCount > 0" :page_number=pageNumber :max_page_number=maxPageNumber
                           @changePageNumber="changePageNumberHandler"/>
        </template>
      </template>
      <div v-if="isLoadingWait" class="loading_area">
        <div class="loading_bg">
        </div>
        <div class="loading"></div>
      </div>
    </section>
  </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import * as gettersTypes from '@/store/getter-types'
import * as actionTypes from '@/store/action-types'
import * as mutationType from '@/store/mutation-types'
import UnansweredList from '@/components/UnansweredList'
import AnsweredList from '@/components/AnsweredList'
import QuizResultCorrectDialog from '@/components/QuizResultCorrectDialog'
import QuizResultIncorrectDialog from '@/components/QuizResultIncorrectDialog'
import PageNavigation from '@/components/PageNavigation'
import BeforeLoginUnansweredList from '@/components/BeforeLoginUnansweredList'
import Util from '@/modules/Util'

export default {
  name: 'Top',
  created () {
    this.$store.dispatch(actionTypes.setUp, {
      token: this.token
    })
  },
  components: {
    BeforeLoginUnansweredList,
    PageNavigation,
    QuizResultIncorrectDialog,
    QuizResultCorrectDialog,
    AnsweredList,
    UnansweredList
  },
  computed: {
    ...mapGetters([
      gettersTypes.beforeLoginInformation,
      gettersTypes.unansweredInformation,
      gettersTypes.answeredInformation,
      gettersTypes.isUnansweredListView,
      gettersTypes.isLogin,
      gettersTypes.resultCorrectInformation,
      gettersTypes.resultIncorrectInformation,
      gettersTypes.pageNumber,
      gettersTypes.maxPageNumber,
      gettersTypes.point,
      gettersTypes.isLoadingWait,
      gettersTypes.isSetUp
    ]),
    token () {
      return window.vars.token
    },
    viewPoint () {
      return this.point.toLocaleString()
    },
    limitedQmListCount () {
      let qmList = {}
      if (this.isUnansweredListView) {
        qmList = Util.limitedQmList(this.pageNumber, this.getUnansweredQmList)
      } else {
        qmList = Util.limitedQmList(this.pageNumber, this.getAnsweredQmList)
      }
      return Object.keys(qmList).length
    },
    isResultCorrect () {
      return this.resultCorrectInformation !== null
    },
    resultCorrectInformationHintUrl () {
      return this.resultCorrectInformation.hint_url
    },
    resultCorrectInformationQmId () {
      return this.resultCorrectInformation.qm_id
    },
    resultCorrectInformationPoint () {
      return this.resultCorrectInformation.point
    },
    resultCorrectInformationCorrectText () {
      return this.resultCorrectInformation.correct_text
    },
    resultCorrectInformationAnswerText () {
      return this.resultCorrectInformation.selection
    },
    isResultIncorrect () {
      return this.resultIncorrectInformation !== null
    },
    resultIncorrectInformationQmId () {
      return this.resultIncorrectInformation.qm_id
    },
    resultIncorrectInformationHintUrl () {
      return this.resultIncorrectInformation.hint_url
    },
    quizFilterUnansweredStyle () {
      return this.quizFilterStyle(this.isUnansweredListView)
    },
    quizFilterAnsweredStyle () {
      return this.quizFilterStyle(!this.isUnansweredListView)
    },
    getBeforeLoginQmList () {
      return this.beforeLoginInformation.qm_list
    },
    getBeforeLoginQsmLists () {
      return this.beforeLoginInformation.qsm_lists
    },
    getUnansweredQmList () {
      return this.unansweredInformation.qm_list
    },
    getUnansweredQsmLists () {
      return this.unansweredInformation.qsm_lists
    },
    getAnsweredQmList () {
      return this.answeredInformation.qm_list
    },
    getAnsweredQsmLists () {
      return this.answeredInformation.qsm_lists
    }
  },
  methods: {
    quizFilterStyle (isUnansweredListView) {
      if (isUnansweredListView) {
        return {
          'z-index': 1,
          'background': '#ec8dae',
          'color': '#fff'
        }
      }
      return {
        'z-index': 0,
        'color': '#ec8dae'
      }
    },
    getDateTime (timestamp) {
      const dateTime = new Date(timestamp * 1000)
      const y = dateTime.getFullYear()
      const m = dateTime.getMonth() + 1
      const d = dateTime.getDate()
      return `${y}/${m}/${d}`
    },
    /**
       * 正解のテキストを返す
       * @param groupId
       * @returns {string}
       */
    getAnsweredQsmSelection (groupId) {
      const qsmList = this.answeredInformation.qsm_lists[groupId]
      const keys = Object.keys(qsmList)
      const len = keys.length
      for (let i = 0; i < len; i += 1) {
        const key = keys[i]
        const qsm = qsmList[key]
        if (qsm.correct_flag) {
          return qsm.selection
        }
      }
      return ''
    },
    quizFilterClickHandler () {
      this.$store.commit(mutationType.switchingListView)
    },
    resultCorrectCloseClickHandler () {
      this.$store.commit(mutationType.removeResultCorrectInformation)
    },
    resultIncorrectCloseClickHandler () {
      this.$store.commit(mutationType.removeResultIncorrectInformation)
    },
    clickSelectionHandler ({ qmId, qsmId }) {
      this.$store.dispatch(actionTypes.answer, {
        token: this.token,
        qmId,
        qsmId
      })
    },
    clickQuizButtonHandler ({ qmId }) {
      if (this.isLogin) {
        this.$store.dispatch(actionTypes.countUpHintView, {
          token: this.token,
          qmId
        })
      }
    },
    /**
       * ページボタンクリック時のハンドラ
       * @param pageNumber
       */
    changePageNumberHandler ({ pageNumber }) {
      this.$store.commit(mutationType.setPageNumber, {
        pageNumber
      })
    }
  }
}
</script>

<style scoped>
  /*@import "../font.css";*/
  /*@import "../style.css";*/

  #fansite_quiz {
    /*background: url("/campaign/images/bg.gif");*/
  }

  .main {
    background: transparent;
    line-height: 1;
  }

  .main ul {
    list-style: none;
  }

  .main a {
    margin: 0;
    padding: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    text-decoration: none;
  }

  .main .main_content {
    position: relative;
    width: 990px;
    margin-left: auto;
    margin-right: auto;
  }

  @media screen and (max-width: 767px) {
    .main .main_content {
      width: 92%;
      margin: 0 auto;
    }
  }

  .main h1 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .main .quiz_title_text {
    width: 60%;
    max-width: 360px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .main .quiz_title_icon_left {
    width: 96px;
    padding-top: 15%;
    background: url("../assets/quiz_top_icon_bat.png") no-repeat left center;
    background-size: contain;
  }

  @media screen and (max-width: 767px) {
    .main h1 {
      padding: 30px 0 0;
    }
  }

  @media screen and (max-width: 767px) {
    .main .quiz_title_icon_left {
      width: 15%;
      max-width: 75px;
      background: url("../assets/quiz_top_icon_bat.png") no-repeat left center;
      background-size: contain;
    }
  }

  .main .quiz_title_icon_right {
    width: 96px;
    padding-top: 15%;
    background: url("../assets/quiz_top_icon_round.png") no-repeat right center;
    background-size: contain;
  }

  @media screen and (max-width: 767px) {
    .main .quiz_title_icon_right {
      width: 15%;
      max-width: 75px;
      background: url("../assets/quiz_top_icon_round.png") no-repeat right center;
      background-size: contain;
    }
  }

  .main h1 span {
    color: #ec8dae;
    display: block;
    line-height: 1.5;
    position: relative;
    /*z-index: 1;*/
    font-weight: 700;
  }

  @media screen and (min-width: 768px) {
    .main h1 span:not(.sub) {
      font-size: 43px;
    }
  }

  @media screen and (min-width: 768px) {
    .main h1 span.sub {
      font-size: 20px;
    }
  }

  @media screen and (max-width: 767px) {
    .main h1 span:not(.sub) {
      font-size: 6.0vw;
    }
  }

  .main h1 span.sub {
    letter-spacing: 0;
  }

  @media screen and (max-width: 767px) {
    .main h1 span.sub {
      font-size: 2.9vw;
    }
  }

  .quiz_top .quiz_menu {
    margin: 50px 88px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-align-items: flex-end;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_menu {
      margin: 7% 0;
      -webkit-flex-wrap: wrap-reverse;
      -ms-flex-wrap: wrap-reverse;
      flex-wrap: wrap-reverse;
    }
  }

  .quiz_filter {
    width: 512px;
    height: 56px;
    position: relative;
  }

  @media screen and (max-width: 767px) {
    .quiz_filter {
      width: 100%;
    }
  }

  .quiz_filter_unanswered {
    position: absolute;
    left: 0;
    width: 280px;
    height: 56px;
    border-radius: 56px 0 56px 0;
    font-size: 18px;
    font-weight: bold;
    border: 2px solid #ec8dae;
    line-height: 56px;
    text-align: center;
    background: #fff;
    outline: none;
  }

  @media screen and (max-width: 767px) {
    .quiz_filter_unanswered {
      border-radius: 25px 0 25px 0;
      width: 53%;
    }
  }

  .quiz_filter_answered {
    position: absolute;
    right: 0;
    width: 280px;
    height: 56px;
    border-radius: 56px 0 56px 0;
    font-size: 18px;
    font-weight: bold;
    border: 2px solid #ec8dae;
    line-height: 56px;
    text-align: center;
    background: #fff;
    outline: none;
  }

  @media screen and (max-width: 767px) {
    .quiz_filter_answered {
      border-radius: 25px 0 25px 0;
      width: 53%;
    }
  }

  .quiz_filter .filter_active {
    background: #ec8dae;
    color: #fff;
    /*z-index: 1;*/
  }

  .quiz_filter .filter_inactive {
    background: #fff;
    color: #ec8dae;
    /*z-index: 0;*/
  }

  /*.quiz_filter:hover {*/
  /*  background: #fbe8ee;*/
  /*  cursor: pointer;*/
  /*}*/

  .quiz_filter_unanswered:hover {
    background: #fbe8ee;
    cursor: pointer;
  }

  .quiz_filter_unanswered:disabled {
    cursor: default;
  }

  .quiz_filter_answered:hover {
    background: #fbe8ee;
    cursor: pointer;
  }

  .quiz_filter_answered:disabled {
    cursor: default;
  }

  .point {
    width: 199px;
    height: 94px;
    border-radius: 10px;
    position: relative;
    background: #4fc9d7;
    padding: 12px 7px 7px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .point {
      width: 100%;
      height: auto;
      padding: 10px 10px;
      margin-bottom: 7%;
    }
  }

  .point h2 {
    color: #fff;
    font-size: 18px;
    text-align: center;
    display: block;
    font-weight: 500;
    margin: 0;
  }

  @media screen and (max-width: 767px) {
    .point h2 {
      display: none;
    }
  }

  .point h2 span {
    margin: 3px 0 12px;
    font-size: 12px;
    display: block;
  }

  .point p {
    margin: 0;
    width: 100%;
    padding: 5px 0;
    background: #fff;
    border-radius: 10px;
    text-align: center;
    color: #463e2e;
    position: relative;
  }

  @media screen and (max-width: 767px) {
    .point p {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
    }
  }

  .point p span {
    font-size: 32px;
    font-weight: bold;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .point p span {
      -webkit-box-pack: start;
      -webkit-justify-content: flex-start;
      -ms-flex-pack: start;
      justify-content: start;
    }
  }

  .point p span:before {
    content: "";
    width: 40px;
    height: 40px;
    min-width: 40px;
    bottom: -1px;
    position: relative;
    background: url("../assets/icon_point.svg") no-repeat left center;
  }

  @media screen and (max-width: 767px) {
    .point p:before {
      content: "現在のポイント";
      position: relative;
      text-align: center;
    }
  }

  .quiz_top .quiz_no_login {
    margin: 0 45px;
    min-width: 900px;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_no_login {
      margin: 0 3%;
      min-width: auto;
    }
  }

  .quiz_top .quiz_no_login .quiz_no_login_image {
    height: 516px;
    background: url("../assets/quiz_top_limited_info.png") no-repeat left center;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_no_login .quiz_no_login_image {
      width: 100%;
      height: 0;
      padding-top: 92%;
      background: url("../assets/quiz_top_limited_info_sp.png") no-repeat left center;
      background-size: 100%;
      margin-bottom: 90px;
    }
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area {
    text-align: center;
    position: relative;
    top: 150px;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_no_login .quiz_no_login_image .submit_area {
      width: 100%;
      top: 30px;
    }
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt {
    -webkit-box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt {
    width: 418px;
    margin: 30px auto 0;
    padding: 20px 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #66c8d9;
    border-radius: 30px;
    color: #fff;
    font-weight: bold;
    border: 1px solid #fff;
    font-size: 20px;
    line-height: 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt {
      width: 100%;
    }
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt span {
    -webkit-box-flex: 2;
    -webkit-flex-grow: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    font-weight: 500;
    letter-spacing: .05em;
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt:after {
    content: "";
    background: url("../assets/icon_footmenu_white.svg") no-repeat center;
    background-size: contain;
    width: 12px;
    height: 12px;
  }

  .quiz_top .quiz_no_login .quiz_no_login_image .submit_area .submit_bt:hover {
    opacity: .8;
  }

  .quiz_top .quiz_no_login > span {
    width: 900px;
    display: inline-block;
    margin: 50px 0;
    text-align: center;
    color: #ec8dae;
    font-weight: bold;
  }

  @media screen and (max-width: 767px) {
    .quiz_top .quiz_no_login > span {
      width: 100%;
      margin: 5% 0;
    }
  }

  .quiz_top .quiz_bt_area .quiz_bt > span {
    -webkit-box-flex: 2;
    -webkit-flex-grow: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    font-weight: 500;
    font-size: 30px;
    letter-spacing: .05em;
  }

  .loading_area {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .loading_bg {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.2;
  }

  .loading {
    position: relative;
    width: 300px;
    height: 300px;
    background: url("../assets/loading.svg") no-repeat left center;
    animation: anim 1s steps(8) infinite;
    opacity: 0.5;
  }

  @media screen and (max-width: 767px) {
    .loading {
      width: 150px;
      height: 150px;
    }
  }

  @keyframes anim {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
